var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 195.203L390.403 35.203C388.872 33.188 386.528 32 383.997 32H128.003C125.472 32 123.128 33.188 121.597 35.203L1.6 195.203C-0.713 198.266 -0.494 202.547 2.1 205.391L250.094 477.391C251.594 479.047 253.75 480 256 480S260.406 479.047 261.906 477.391L509.9 205.391C512.494 202.547 512.713 198.266 510.4 195.203ZM383.796 53.064L487.995 192H272.65L383.796 53.064ZM256 187.188L144.653 48H367.347L256 187.188ZM128.204 53.064L239.35 192H24.005L128.204 53.064ZM256 460.125L26.13 208H485.87L256 460.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.d800a7d314407ac7a0655c8199b7ce73.svg";
export { ForwardRef as ReactComponent };